import Vue from 'vue';
import {DtoApiGetUserDetailsRequest} from "@/classes/dto/api/user/dto.api.get-user-details.request";
import {DtoApiSaveLoginPreferenceRequest} from "@/classes/dto/api/user/dto.api.save-login-preference.request";

export default ({
  namespaced: true,
  state: () => ({
    profileDetails: null
  }),
  actions: {
    async getProfileDetails({state}) {
      const res = await new DtoApiGetUserDetailsRequest().$get()

      if (res.$error) {
        console.log(res.$error)
      } else {
        state.profileDetails = res.data
      }
    },
    async saveLoginPreference(_, payload) {
      const res = await new DtoApiSaveLoginPreferenceRequest().$post(payload)

      if (res.$error) {
        console.log(res.$error)
      } else {
        Vue.$toast.open({
          message: 'Login preference saved successfully.',
          type: 'success',
          dismissible: true
        })
      }
    },
  },
  getters: {
    profileDetails: state => state.profileDetails
  }
})